var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.$style.container },
    [
      _c("div", { class: _vm.$style.header }, [
        _c(
          "div",
          { class: [_vm.$style.row, _vm.$style.heading] },
          [
            _vm._t("woc-heading", [
              _c("div", { class: _vm.$style.slotHeading }, [
                _c("span", { class: _vm.$style.title }, [
                  _vm._v(_vm._s(_vm.title))
                ]),
                _vm._v(" "),
                _c("span", { class: _vm.$style.productCount }, [
                  _vm._v(_vm._s(_vm.productCountLabel))
                ])
              ])
            ])
          ],
          2
        ),
        _vm._v(" "),
        _vm.sortedSkus.length > 0
          ? _c(
              "div",
              { class: [_vm.$style.row, _vm.$style.sort] },
              [
                _c("div", { class: _vm.$style.sortBy }, [
                  _vm._v(_vm._s(_vm.sortByLabel))
                ]),
                _vm._v(" "),
                _c(
                  "NsSlottedDropdown",
                  {
                    class: _vm.$style.sortDropdown,
                    attrs: {
                      selected: _vm.sortByValue,
                      placeholder: _vm.selectPlaceholder
                    },
                    on: { select: _vm.sortSelect }
                  },
                  _vm._l(_vm.sortOptions, function(opt) {
                    return _c(
                      "div",
                      { key: opt.id, attrs: { "data-value": opt.id } },
                      [_c("span", [_vm._v(_vm._s(opt.title))])]
                    )
                  }),
                  0
                )
              ],
              1
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.showSpinnerOnFirstLoad
        ? _c("div", { class: _vm.$style.spinnerWrapper }, [_c("NsSpinner")], 1)
        : _c("NsProductList", {
            attrs: {
              items: _vm.sortedSkus,
              "mobile-side-by-side": _vm.mobileSideBySide,
              "skus-per-load": _vm.skusPerLoad
            },
            on: { "product-update": _vm.handleProductUpdate }
          })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }